import React, { useContext, useState } from "react";
import "./webinarLandingPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import AbuotUs from "../../assets/images/new/media.png";
import Abuotws from "../../assets/images/new/media-two.png";
import "swiper/css";
import "swiper/css/navigation";

import batuk from "../../assets/images/new/fav-removebg-preview.png";
import whyChooseUsImg from "../../assets/images/new/whyChooseUs.png";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import { useNavigate } from "react-router-dom";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import LazySection from "../Home/LazySection";
import FAQSection from "../../Components/FAQSection/FAQ";
import mainLogo from "../../../src/assets/images/new/logo.png";
import { WebinarUser } from "../../ApiServices/Webinar/WebinarApi";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import axios from "axios";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { Helmet } from "react-helmet-async";
import RazorpayWebinarPaymentButton from "./RazorpayWebinarPaymentButton";
import ComingSoonModal from "../../Components/ComingSoonModal";

const WebinarLandingPage = () => {
  const { setLoader } = useContext(LoaderContext);
  const slides = [
    {
      image: "../../assets/images/new/aboutPageImg.png",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "85%",
      goal: "$23,000 Goals",
      donated: "$9,000 Donate",
      color: "#ffa415",
      shape: "assets/images/shapes/d-shape-1.png",
    },
    {
      image: "assets/images/donation/donation-1-2.jpg",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "80%",
      goal: "$13,000 Goals",
      donated: "$5,000 Donate",
      color: "#ff5528",
      shape: "assets/images/shapes/d-shape-2.png",
    },
    // Add more slides here if needed
  ];
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const [contactData, setContactData] = useState({
    email: null,
    LastName: null,
    email: null,
    mobileNumber: null,
    Message: null,
  });
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);

  const metaDataDetails = {
    MetaTitle: 'Ganeshotsav Puja Rituals Webinar | Myomnamo Complete Guide',
    MetaDescription: "Join Myomnamo's Ganeshotsav webinar! Learn the complete guide to Ganesh Puja rituals, traditions & tips for a blissful celebration.",
    OpenGraphTag: "Myomnamo Presents Webinar: Complete Guide to Ganeshotsav Puja Rituals",
    CanonicalTag: "https://www.myomnamo.com/webinar",

  }

  function onCaptchaChange(value) {

    setVerified(true);
  }

  const handleContactFormSubmit = () => {
    let isValid = false;
    if (
      contactData.fullName === "" ||
      contactData.fullName === undefined ||
      contactData.fullName === null ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.mobileNumber === "" ||
      contactData.mobileNumber === undefined ||
      contactData.mobileNumber === null ||
      contactData?.mobileNumber?.length !== 10 ||
      // contactData.Message === "" ||
      // contactData.Message === undefined ||
      // contactData.Message === null ||
      contactData.email === "" ||
      contactData.email === undefined ||
      contactData.email === null
    ) {
      isValid = true;
      setError(true);
    } else if (
      contactData.email !== null &&
      !validateEmail(contactData.email)
    ) {
      isValid = true;
      setError(true);
    }

    const api_params = {
      fullName: contactData.fullName,
      LastName: contactData.LastName,
      email: contactData.email,
      mobileNumber: contactData.mobileNumber,
      Message: contactData.Message,
    };

    if (!isValid) {
      handleRazorpayPayment();
    }
  };


  const WebinarUserData = async (api_params) => {

    try {
      const res = await WebinarUser(api_params);

      if (res.ResponseMessage === "Success.") {

        navigate("/thank-you", {
          state: { moduleName: "ContactUs" },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeAll = () => {
    //  ;
    setShowSuccessPopUp(false);
    setInitialData();
  };

  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      fullName: "",
      LastName: "",
      email: "",
      mobileNumber: "",
      Message: "",
    }));
  };
  //   const WebinarUserData = (params) => {
  //     const templateParams = {
  //       Name: params.name,
  //       email: params.email,
  //       "Mobile Number": params.mobileNo,
  //       message: params.message,
  //       //   to_name: "Velvet Admin",
  //       //   from_name: "Velvet mail service",
  //       //   receiver_email: "velvetgps@gmail.com",
  //     };

  //     emailjs
  //       .send(
  //         "service_wp19bkh", // Service ID
  //         "template_b9wrsrm", // Template ID
  //         templateParams, // Template Parameters
  //         "e5YUU5XlmWckFjZk_" // Public Key
  //       )
  //       .then(
  //         () => {
  //         
  //           setShowThanksModal(true);
  //         },
  //         (error) => {
  //           
  //         }
  //       );
  //   };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    if (id === "fullName" || id === "lastName") {
      value = value.replace(/[^a-zA-Z\s]/g, '');
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (id === "mobileNumber") {
      value = value.charAt(0) >= '6' ? value.replace(/\D/g, '').slice(0, 10) : ''; // Only keep digits and slice to 10 digits
    }

    setContactData((prev) => ({ ...prev, [id]: value }));
  };


  const handleRazorpayPayment = async () => {

    let orderIDReturned = null
    setLoader(true)
    const PlaceOrderResponse = await handleProceedRemainingPayment('51')


    if (PlaceOrderResponse?.status === 1) {

      axios
        .post(`${BaseUrl}/Webinar/WebinarUser`, {
          Name: contactData.fullName,
          EmailID: contactData.email,
          WhatsappNumber: contactData.mobileNumber,
          WebinarFee: 51,
          PaymentStatus: true,
          TransactionID: PlaceOrderResponse?.razorpay_payment_id

        })
        .then((res) => {
          if (res) {


            orderIDReturned = res.data.ID;
            setLoader(false)
            // navigate("/thank-you", {
            //   state: { moduleName: "WebinarPage" },
            // });
            setInitialData()
            setShowComingSoonModal(true)
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Payment Failed !')
    }
  };

  const HandleJoinNowClicked = () => {
    window.open(
      "https://rzp.io/rzp/zuxHv7iu",
      "_blank"
    );
  };


  return (
    <>
      <Helmet>
        <title>{metaDataDetails?.MetaTitle}</title>
        <meta name="description" content={metaDataDetails?.MetaDescription} />
        <link rel="canonical" href={metaDataDetails?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={metaDataDetails?.OpenGraphTag} />
        <meta
          property="og:description"
          content="Celebrate Ganeshotsav with devotion & knowledge. Join our webinar to learn step-by-step Ganesh Puja rituals & traditions."
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/webinar`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaDataDetails?.MetaTitle} />
        <meta
          name="twitter:description"
          content={metaDataDetails?.MetaDescription}
        />


        <script>
          {`
            !function(f,b,e,v,n,t,s){
              if(f.fbq) return; 
              n=f.fbq=function(){n.callMethod ? 
              n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
              if(!f._fbq) f._fbq=n;
              n.push=n; n.loaded=!0; n.version='2.0';
              n.queue=[]; t=b.createElement(e); t.async=!0;
              t.src=v; s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '24982247501377559');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=24982247501377559&ev=PageView&noscript=1"/>`}
        </noscript>


      </Helmet>


      {/* <section className="about-three">
        <div className="sec-title text-center" style={{ paddingBottom: "0px" }}>
          <h6
            className="sec-title__tagline"
            style={{
              perspective: "400px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img className=" tagline-img" src={batuk} alt="" /> Webinar Topic:

         
          </h6>
          <h3
            className="sec-title__title"
            style={{
              perspective: "400px",
              textAlign: "center",
              marginBottom: "50px",
            }}
          >
         The webinar is divided in to below 2 topics.

          </h3>
        </div>
        <div className="container">
            
          <div className="row">
            <div className="col-lg-8 wow fadeInLeft" data-wow-delay="100ms">
              <div className="about-three__content">
               
                <p
                  className="about-three__content__text text-dark"
                  style={{ textAlign: "justify" }}
                >
                 <ul className="text-muted ps-4">
                        <li>The main rituals of Ganesh Chaturthi: Pranapratishhtha (invoking life into the idol), Shhodashopachara (16 types of offerings), Uttarpuja (farewell ritual), and Ganpati Visarjan (immersion of the idol).
</li>
                        <li>Step-by-step explanation of the puja vidhi, including significance and meanings behind each ritual gesture
</li>
                        
                      </ul>
                </p>
               
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className=""
                data-wow-delay="200ms"
                style={{
                  paddingTop: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="about-three__image__shape-one">
                 
                </div>
                <img src={whyChooseUsImg} className="height2" alt="careox" />
                <div
                  className="about-three__image__right wow fadeInUp"
                  data-wow-delay="300ms"
                >
                 
                </div>
                <div className="about-three__image__shape-two">
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="contact-section-custom py-5 mobile-secone">
        <div className="container">
          <div className="row align-items-center">
            {/* Left: Content */}
            <div
              className="col-lg-6 mb-4 mb-lg-0 wow fadeInLeft main-topicwebinar"
              data-wow-delay="100ms"
            >
              <div className="about-three__content">
                {/* Logo */}

                {/* Section Title */}
                <div className="sec-title main-time">
                  <div className="logoenglish" style={{ textAlign: "left" }}>
                    <img
                      src={mainLogo}
                      alt="Myomnamo Logo"
                      style={{ maxWidth: "194px", height: "auto" }}
                    />
                  </div>
                  <h3 className="sec-title__title bw-split-in-left webinar-head">
                    Myomnamo Presents Webinar 2025
                  </h3>
                  <h6
                    className="sec-title__tagline bw-split-in-right mobile-heading"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      marginBottom: "7px",
                      marginTop: "13px",
                      color: "black",
                    }}
                  >
                    <strong className="marathi" >Topic : </strong>  Importance of Ganesh Utsav
                  </h6>
                  <button type="submit" onClick={() => HandleJoinNowClicked()} className="careox-btn  mobile-but">
                    <span>Join Now</span>
                  </button>
                </div>

                {/* Content */}
                <div
                  className="about-three__content__text text-dark"
                  style={{ textAlign: "justify" }}
                >
                  <p className="webinarpara">
                    Ganesh Utsav is a festival that unites people across India,
                    especially in Maharashtra, celebrating the aarti’s rhythm.
                    It holds a special place in every Maharashtrian’s heart and
                    falls on Bhadrapada’s fourth day (Chaturthi).
                  </p>
                  <ul className="webinar-list">
                    <li>
                      <strong>Ganesh Chaturthi:</strong> 27th August 2025
                    </li>
                    <li>
                      <strong>Webinar Date:</strong> 18th August 2025
                    </li>
                    <li>
                      <strong>Time:</strong> 11:00 AM to 1:30 PM
                    </li>
                    <li>
                      <strong>Language:</strong> Marathi
                    </li>
                    <li>
                      <strong>Charges:</strong> ₹51
                    </li>
                    <li>
                      <strong>Platform:</strong> Zoom
                    </li>
                  </ul>
                  <button type="submit" onClick={() => HandleJoinNowClicked()} className="careox-btn button-webinar">
                    <span>Join Now </span>
                  </button>
                </div>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="col-lg-6">
              <div className="form-card shadow-sm rounded bg-white padding-webinar">
                <div className="row gy-3">
                  {/* First Name */}

                  <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                    Contact Information
                  </h3>
                  <div className="col-md-12 col-webinar">
                    <label className="form-label-custom webinar-label">
                      Full Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      value={contactData?.fullName}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="Enter Full Name"
                      maxLength={50}
                    />
                    {error && (contactData?.fullName === null || contactData?.fullName === undefined || contactData?.fullName === "") ? <span className="text-danger " style={{ fontSize: '14px' }}>{ERROR_MESSAGES}</span> : ''}
                  </div>

                  {/* Last Name */}
                  {/* <div className="col-md-6 col-webinar">
                    <label className="form-label-custom webinar-label">
                      Last Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input webinar-form"
                      placeholder="Enter Last Name"
                    />
                  </div> */}

                  {/* Mobile */}
                  <div className="col-md-6 col-webinar">
                    <label className="form-label-custom webinar-label">
                      WhatsApp No. <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="mobileNumber"
                      value={contactData?.mobileNumber}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      maxLength={10}
                      placeholder="Enter  WhatsApp No."
                    />
                    {error && (contactData?.mobileNumber === null || contactData?.mobileNumber === undefined || contactData?.mobileNumber === "") ? <span className="text-danger " style={{ fontSize: '14px' }}>{ERROR_MESSAGES}</span> : (error && (contactData?.mobileNumber !== null && contactData?.mobileNumber !== "" && contactData?.mobileNumber !== undefined && contactData?.mobileNumber?.length !== 10)) ? <span className="text-danger" style={{ fontSize: '14px' }}>Invalid Mobile Number</span> : ""}
                  </div>

                  {/* email */}
                  <div className="col-md-6 col-webinar ">
                    <label className="form-label-custom webinar-label">
                      email <span>*</span>
                    </label>
                    <input
                      value={contactData?.email}
                      type="email"
                      id="email"
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="Enter email"
                    />
                    {error && (contactData?.email === null || contactData?.email === undefined || contactData?.email === "") ? <span className="text-danger" style={{ fontSize: '14px' }}>{ERROR_MESSAGES}</span> : (error && (contactData?.email !== null && contactData?.email !== undefined && contactData?.email !== "" && !validateEmail(contactData?.email))) ? <span className="text-danger" style={{ fontSize: '14px' }}>Invalid Email ID</span> : ''}
                  </div>

                  {/* Message */}
                </div>

                {/* Submit */}
                <div className="mt-0 text-start">
                  <button
                    type="submit"
                    className="careox-btn wbinar-form submit-button"
                    onClick={() => handleContactFormSubmit()}
                  >
                    <span>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="donate-page">
        <div className="container">
          <div className="row">
            {/* Left Column: Donation Form */}
            <div className="col-lg-8">
              <div className="donate-page__content">
                <div className="donate-page__notice p-4 rounded shadow-sm bg-light border">
                  <div className="donate-page__notice__icon mb-3"></div>

                  <div className="ganesh-rituals">
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >
                      <img className="tagline-img" src={batuk} alt="" />
                      A Beautiful Beginning to Ganeshotsav!
                    </h6>
                    <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                      Ganpati Bappa Morya – Complete Guide to Puja Rituals
                    </h3>
                    <p className="webinar-paragraph">
                      Even in today’s busy life, fulfilling your religious and spiritual needs has become easy — with the help of Myomnamo! From puja, darshan, personal guru services to convenient puja kits, everything can be accessed right from your home. Experience the preservation of your culture and inner peace under the guidance of experienced, honest, and traditional priests. Wherever you are, we bring the divine experience to your doorstep. Our mission is to make spirituality accessible, meaningful, and effortless for everyone. Join thousands who have already embraced this seamless spiritual journey. So don’t delay your puja, darshan, and spiritual guidance! With Myomnamo, devotion meets convenience like never before. Let your every day begin with divine blessings and end with inner peace. Step into a world where faith.
                    </p>
                    <h5>Myomnamo's 27 Key Services:</h5>
                    <div className="grid-container">
                      <div className="list-column">
                        <ul className="mb-3 vebinarlist">
                          <li>Online Puja Booking with Experienced and Honest Priests</li>
                          <li>Online Booking for Bhajan and Kirtan</li>
                          <li>Daily Priest Service (At Home/Office)</li>

                          <li>Astrology Services</li>
                          <li>Vastu Consultation</li>
                          <li>Numerology Services</li>
                          <li>Tarot Card Reading</li>
                          <li>Palmistry Analysis</li>
                          <li>Meditation Center Booking</li>
                        </ul>
                      </div>
                      <div className="list-column">
                        <ul>
                          <li>Brahmin Feast Management</li>
                          <li>Funeral Services</li>
                          <li>Shraddha Services</li>
                          <li>Pilgrimage Management</li>
                          <li>Online Temple Dakshina</li>
                          <li>Online Prasad Delivery</li>
                          <li>Spiritual Blog and Knowledge</li>
                          <li>Virtual Puja Services</li>
                          <li>Complete Puja Management </li>
                          <li>Spiritual Event Management</li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Right Column: Swiper Carousel */}
            <div className="col-lg-4">
              <div className="donate-page__sidebar">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  slidesPerView={1}
                  // autoplay={{ delay: 3000, disableOnInteraction: false }}
                  navigation={true}
                >
                  {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="donations-one__item"
                        style={{ "--accent-color": slide.color }}
                      >
                        <div className="donations-one__item__image">
                          <img src={AbuotUs} alt="careox" />
                          <a
                            href="donation-details.html"
                            className="donations-one__item__image__link"
                          ></a>
                        </div>
                        <div className="donations-one__item__content">
                          <h6
                            className="sec-title__tagline bw-split-in-right addingheading-webinar"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                            }}
                          >
                            Proper method for Ganesh Puja!
                          </h6>
                          <ul className="donation-details__author__list">
                            <li>
                              <i className="icofont-ui-calendar"></i> Ganesh Chaturthi: 27 August 2025
                            </li>
                            <li>
                              <i className="icofont-ui-calendar"></i> Webinar Date: 18 August 2025
                            </li>
                            <li>
                              <i className="icofont-clock-time"></i> Time: 11:00 AM to 1:30 PM
                            </li>
                            <li>
                              <i className="icofont-flag"></i> Language: Marathi
                            </li>
                            <li>
                              <i className="icofont-money"></i> Charges: ₹51
                            </li>
                            <li>
                              <i className="icofont-video-cam"></i> Platform: Zoom
                            </li>
                          </ul>
                          <button
                            type="submit"
                            className="careox-btn button-webinar"
                            style={{ margin: "20px" }}
                            onClick={() => HandleJoinNowClicked()}
                          >
                            <span>Join Now</span>
                          </button>


                          {/* <RazorpayWebinarPaymentButton /> */}

                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>


          </div>
        </div>
      </section>
      {/* End of Donate Section */}

      <LazySection>
        <FAQSection />
      </LazySection>
      <DownloadApp />
      <ComingSoonModal
        show={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        moduleName='e-webinar'
      />
    </>
  );
};

export default WebinarLandingPage;
